
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/start-here/core-technology-discussions/antara",
      function () {
        return require("private-next-pages/en/docs/start-here/core-technology-discussions/antara/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/start-here/core-technology-discussions/antara"])
      });
    }
  